import * as React from 'react';
import { connect } from 'react-redux';
import { createRouteNodeSelector } from 'redux-router5';

import CurrentOrgInjector from '~/apps/shared/containers/app/CurrentOrgInjector';
import TransactionListComp from '~/apps/shared/containers/transactions/TransactionList';
import { parseTransactionFilter } from '~/apps/shared/services/qsfilter';


const TransactionList = (props) => {
  const { transactions, route: { params } } = props;

  const filter = parseTransactionFilter(params);

  return (
    <CurrentOrgInjector
      component={TransactionListComp}
      showOrganization={true}
      filter={filter}
      onClick={(transactionId: string) => {
        const transaction = transactions.entities[transactionId];
        if (transaction && transaction.receiptUrl) {
          window.open(transaction.receiptUrl);
        }
      }}
    />
  );
}

const mapStateToProps = (state) => {
  const routeNodeSelector = createRouteNodeSelector('sender');

  return {
    transactions: state.shared.transactions,
    ...routeNodeSelector(state),
  }
};

export default connect(mapStateToProps)(TransactionList);

